import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class BroadcastMessageGraphql extends GraphQlService {
  async getAllBroadcastMessages() {
    return this.client
      .query({
        query: gql`
          query {
            getAllBroadcastMessages {
              id
              startDate
              endDate
              message
              heading
              userType
              status
              isAllAccount
              authAccounts{
                id
                name
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.getAllBroadcastMessages);
  }

  // `pagination` optional — omitted entirely, the backend returns the full
  // set in one call (same convention as UsersGraphqlInstance.getAllUsers).
  // Provided (limit/offset at minimum), it paginates/searches/sorts at the
  // database instead.
  async getBroadcastMessagesPage(pagination = {}) {
    const { limit, offset, search, sortField, sortOrder } = pagination;
    return this.client
      .query({
        query: gql`
          query GetBroadcastMessages(
            $limit: Float
            $offset: Float
            $search: String
            $sortField: String
            $sortOrder: String
          ) {
            getBroadcastMessages(
              limit: $limit
              offset: $offset
              search: $search
              sortField: $sortField
              sortOrder: $sortOrder
            ) {
              total
              items {
                id
                startDate
                endDate
                message
                heading
                userType
                status
                isAllAccount
                authAccounts {
                  id
                  name
                }
              }
            }
          }
        `,
        variables: {
          limit: limit ?? null,
          offset: offset ?? null,
          search: search ?? null,
          sortField: sortField ?? null,
          sortOrder: sortOrder ?? null,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getBroadcastMessages);
  }

  async createBroadcastMessage(broadcastMessage) {
    return this.client
      .mutate({
        mutation: gql`
          mutation CreateBroadcastMessages($message: String!, $heading: String!) {
            createBroadcastMessages(
              createBroadcastMessagesInput: {
                isAllAccount: ${broadcastMessage.isAllAccount}
                accountIds: """${JSON.stringify(broadcastMessage.accountIds)}"""
                startDate: "${broadcastMessage.startDate}"
                endDate: "${broadcastMessage.endDate}"
                message: $message
                heading: $heading
                userType: "${broadcastMessage.userType}"
              }
            ) {
              id
            }
          }
        `,
        variables: {
          message: broadcastMessage.message,
          heading: broadcastMessage.heading,
        },
      })
      .then((result) => result?.data?.createBroadcastMessages);
  }

  async updateBroadcastMessage(broadcastMessage) {
    return this.client
      .mutate({
        mutation: gql`
          mutation UpdateBroadcastMessages($message: String!, $heading: String!) {
            updateBroadcastMessages(
              updateBroadcastMessagesInput: {
                id: "${broadcastMessage.id}"
                isAllAccount: ${broadcastMessage.isAllAccount}
                accountIds: """${JSON.stringify(broadcastMessage.accountIds)}"""
                startDate: "${broadcastMessage.startDate}"
                endDate: "${broadcastMessage.endDate}"
                message: $message
                heading: $heading
                userType: "${broadcastMessage.userType}"
              }
            ) {
              id
            }
          }
        `,
        variables: {
          message: broadcastMessage.message,
          heading: broadcastMessage.heading,
        },
      })
      .then((result) => result?.data?.updateBroadcastMessages);
  }

  async updateStatusBroadcastMessages(data) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            updateStatusBroadcastMessages(
              updateStatusBroadcastMessageInput:{
                id: "${data.id}", status: ${data.status}
              }
            ) {
              id
            }
          }
        `,
      })
      .then((result) => result?.data?.updateStatusBroadcastMessages);
  }

  async removeBroadcastMessages(id) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            removeBroadcastMessages(id: "${id}")
          }
        `,
      })
      .then((result) => result?.data?.removeBroadcastMessages);
  }

  async getBroadcastMessagesByUser() {
    return this.client
      .query({
        query: gql`
          query {
            getBroadcastMessagesByUser {
              id
              message
              heading
            }
          }
        `,
      })
      .then((result) => result?.data?.getBroadcastMessagesByUser);
  }

  async createBroadcastMessagesUsers(id) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            createBroadcastMessagesUsers(
              createBroadcastMessagesUsersInput: {
                messageId: "${id}"
              }
            ), {
              id
            }
          }
        `,
      })
      .then((result) => result?.data?.createBroadcastMessagesUsers);
  }

}

const broadcastMessagesInstance = new BroadcastMessageGraphql();
export default broadcastMessagesInstance;
